import axios from 'axios'

const API = 'ganancias'

const ENDPOINTS = {
    postPorcentajeGanancia(form){
        return axios.post(`${API}/porcentaje`,form);
    },
}
export default ENDPOINTS